import {Component, OnInit} from '@angular/core';
import {TicketsService} from '../../../services/tickets.service';
import {FormControl, FormGroup, ReactiveFormsModule, UntypedFormBuilder} from '@angular/forms';
import {Router, RouterLink} from '@angular/router';
import {SendedFile} from '../../../model/SenderFile';
import {forkJoin} from 'rxjs';
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {TicketCommerceModalComponent} from "../ticket-commerce-modal/ticket-commerce-modal.component";
import {FaqCategoryService} from "../../../services/faq-category.service";

import {BreadcrumbComponent} from "../../../components/common/breadcrumb/breadcrumb.component";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {UploadFileComponent} from "../../../components/common/upload-file/upload-file.component";
import {CancelButtonComponent} from "../../../components/common/cancel-button/cancel-button.component";
import {UserTicketFormGeneratorService} from "../../../formulaires/user/user-ticket-form-generator.service";
import {DynamicFormComponent} from "../../../components/common/dynamic-form/dynamic-form.component";
import {ProfileService} from "../../../services/profile.service";
import {Profile} from "../../../model/profile";
import { SpinnerComponent } from 'src/app/components/common/spinner/spinner.component';
import { QuestionControlService } from 'src/app/components/common/fields/question-control.service';

@Component({
    selector: 'app-ticket-create',
    imports: [
    BreadcrumbComponent,
    FaIconComponent,
    ReactiveFormsModule,
    UploadFileComponent,
    CancelButtonComponent,
    SpinnerComponent,
    RouterLink,
    DynamicFormComponent
],
    templateUrl: './ticket-create.component.html',
    styleUrls: ['./ticket-create.component.css']
})
export class TicketCreateComponent implements OnInit {
  queues: Map<string, string> = new Map<string, string>();
  products: Map<string, string> = new Map<string, string>();
  versions: Map<string, string> = new Map<string, string>();
  services: Map<string, string> = new Map<string, string>();
  sla: Map<string, string> = new Map<string, string>();

  sendedFiles: SendedFile[] = [];
  creating = false;
  error = false;
  cdtMode = false;

  allowedProducts: string[] = [];

  // Simple flag to know if the modal is open or not
  commercialModalShowed = false;

  questions = [];
  form = new FormGroup({});
  profile: Profile;


  constructor(private categoryService: FaqCategoryService,
              private ticketService: TicketsService,
              private modalService: NgbModal,
              private profileService: ProfileService,
              private userTicketFormGeneratorService: UserTicketFormGeneratorService,
              private qcs: QuestionControlService,
              protected router: Router) {
  }

  ngOnInit(): void {
    this.profileService.getProfile().subscribe(p => this.profile = p);
    this.categoryService.getObjects().subscribe(p => {
      this.allowedProducts = p.map(c => c.slug.toLowerCase());
    })
    forkJoin([
      this.ticketService.getQueues(),
      this.ticketService.getPossibleVersions(),
      this.ticketService.getServices(),
    ]).subscribe((
      [
        queues,
        versions,
        services
      ]) => {
      this.queues = queues;
      this.versions = versions;
      this.services = services;

      this.generateForm({});

    });
  }

  oldValues: any = {
    queue: '',
    product: ''
  };
  oldFocusId: string;

  generateForm(values ?: any): void {
    this.userTicketFormGeneratorService.getQuestions({
      allowedProducts: this.allowedProducts,
      queues: this.queues,
      products: this.products,
      versions: this.versions,
      services: this.services,
      sla: this.sla,
      cdtMode: this.cdtMode,
      values: values
    }).subscribe(q => {
      this.questions = q;
      this.form = this.qcs.toFormGroup(this.questions, (values) => {
        // Check "commercial" in service name
        if (values.service && this.services[values.service].toLowerCase().indexOf('commercial') !== -1) {
          // Set back the value to empty string
          values.service = '';
          if (!this.commercialModalShowed) {
            this.commercialModalShowed = true;
            this.modalService.open(TicketCommerceModalComponent, {backdrop: 'static'}).result.then(() => {
              // Redirect to ticket listing
              this.router.navigate(['tickets']);
            }).catch(() => {
              this.commercialModalShowed = false;
            });
          }
        }

        if(values.queue) {
          this.cdtMode = this.queues[values.queue].toLowerCase().indexOf('carnet de temps') !== -1;
        }

        // Keep the old focus, as the form will be generated, to be re-applied
        this.oldFocusId = document.activeElement.id;
        // Only trigger reload in case of change of all values except thoses (empty = body)
        if(this.oldFocusId && this.oldFocusId !== 'subject') {
          forkJoin([
            this.ticketService.getProductsWithQueue(values.queue),
            this.ticketService.getSLAWithService(values.service),
          ]).subscribe(([p, sla]) => {
            this.products = p;
            this.sla = sla;
            this.generateForm(values);
          });
        }
        this.userTicketFormGeneratorService.patchValuesFromInstance(values, this.versions);
        this.oldValues = values;
      });
      if(this.oldFocusId) {
        setTimeout(()=>{
          document.getElementById(this.oldFocusId).focus();
        })
      }
    });
  }

  sendedFilesNotFinished(): boolean {
    return this.sendedFiles.some(s => !s.uploaded);
  }

  sendForm(): void {
    let formValue = this.form.value;
    formValue["filesIds"] =  this.sendedFiles.map(sf => sf.id);
    formValue["product"] =  this.oldValues.product;
    formValue["version"] =  this.oldValues.version;
    formValue["hosting"] =  this.oldValues.hosting;
    if(this.oldValues.installId !== 'none') {
      formValue["install"] =  this.oldValues.install;
    }
    formValue["exploit"] =  this.oldValues.exploit;
    if(formValue["installId"] === 'none') {
      delete formValue["installId"];
    }

    this.creating = true;
    this.ticketService.createTicket(this.form.value).subscribe(result => {
      if (result.id === null) {
        // There was an error on ticket creation
        this.creating = true;
        this.error = true;
      } else {
        history.replaceState({}, '', '/tickets');
        this.router.navigate([`/tickets/${result.id}`]);
      }
    });
  }

}
